<template>
    <div v-if="loginModel.openToken == undefined || loginModel.openToken == null || loginModel.openToken == ''"
	class="form-bg">
        <div class="container-fluid" @keyup.enter="dologin()">
        	<div class="row" style="height: 100px;color: rgb(255,255,255);">
        		<div class="col-sm-12" style="padding-top: 20px;">
					<table style="border: none;color: rgb(255,255,255);">
						<tr>
							<td align="middle">
								<img src="../../assets/login/gt_log.png" alt="" width="120px" height="50px">
							</td>
							<td align="middle" style="padding-bottom: 9px;">
								<h1>科创网校综合业务管理平台</h1>
							</td>
						</tr>
					</table>
        		</div>
        	</div>
        	<div class="row" style="height: calc(100% - 200px);">
        		<div class="col-md-offset-8 col-md-4" style="height: 100%;">
        			<form class="form-horizontal" autocomplete="on" style="width: 407px;height: 404px;
					  position: relative;top: 50%;-webkit-transform: translateY(-50%);-moz-transform: translateY(-50%);-ms-transform: translateY(-50%);-o-transform: translateY(-50%);transform: translateY(-50%);">
						<span class="heading">用户登录</span>
        				<div class="form-group">
							<input type="text" autocomplete="off" autofocus class="form-control" v-model="loginModel.username" id="inputEmail3" placeholder="用户名" name="username"  v-validate="{required:true,max:50}" data-vv-as="用户名"><i
        					 class="fa fa-user"></i>
							<span class="error_validate_msg">{{ errors.first('username') }}</span>
						</div>
        				<div class="form-group help">
							<input type="password" autocomplete="off" v-model="loginModel.password" name="password" v-validate="{required:true,max:50}" data-vv-as="密码" class="form-control" id="inputPassword3" placeholder="密　码"><i
        					 class="fa fa-lock"></i>
							 <span class="error_validate_msg">{{ errors.first('password') }}</span>
						</div>
        				<div class="form-group">
							<div style="float: left;">
									<input type="text" autocomplete="off"  placeholder="验证码" class="form-control" style="width: 120px;" v-model="loginModel.code"  name="code" v-validate="{required:true,max:50}" data-vv-as="验证码"/>
									 <span class="error_validate_msg">{{ errors.first('code') }}</span>
							</div>
							<div style="float: right;">
								<img align="absmiddle" id="img_verifycode" @click="reloadImgcode()" style="cursor: pointer;height: 40px;" alt="">
							</div>
        				</div>
						<div class="form-group" >
        					<button @click="dologin"  type="button" class="btn btn-default">登录</button>
						</div>
        			</form>
        		</div>
        	</div>
        	<div class="row" style="height: 100px;color: rgb(255,255,255);">
        		<div class="col-sm-12" style="padding-top: 0px;">
					<center>
						<p>©2019-2020 All Rights Reserved&nbsp;武汉讯网信息技术有限公司&nbsp;版权所有&nbsp;</p>
					</center>
				</div>
        	</div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery';
    export default {
        name: "Login",
        data: function () {
            return {
                loginModel:{
					openToken:this.$route.query.open_token,
                    username:'',
                    password:'',
                    code: ''
                }
            }
        },
		created:function(){
			if(this.$cookies.get("_xunw_admin_logined") && 
				this.$cookies.get("_xunw_admin_logined") == 1) {
				this.$router.push({name:'Home'});
			}
			if(this.loginModel.openToken) {
				this.autoLogin();
			}
		},
        mounted(){
            this.reloadImgcode();
        },
        methods:{
            dologin:function(){
                this.$validator.validateAll().then(result=>{
                    if(result){
                        this.$http.post("/htgl/login",this.loginModel).then(res=>{
							this.$cookies.set("_xunw_admin_logined","1","0");
                        	// 将认证码存入SESSION
                            let data = res.data || {};
                            let user = { //用户
                                id:data.id,
                                js:data.js,
                                jsmc:data.jsmc,
                                yhm:data.yhm,
                                zsxm:data.zsxm,
                                jgId:data.jgId,
                            };
                            let privileges = data.qx || [];  //权限
                            this.$store.commit('setUser',user);
                            this.$store.commit('setPrivileges',privileges);
							let privilegeCodes = data.qxCodes || [];
							this.$store.commit('setPrivilegeCodes',privilegeCodes);
							//默认展示第一个模块的第一个导航的菜单
							if(privileges && privileges.length > 0){
								let modules = privileges.filter(x=>x.type=='module');
								if (modules && modules.length>0) {
									let defaultModule = modules[0];
									if (defaultModule && defaultModule.children && defaultModule.children.length>0){
										this.$store.commit('setActiveModule',defaultModule.code);
										let navs = defaultModule.children.filter(x=>x.type=='nav');
										if(navs && navs.length> 0){
											let defaultNav = navs[0];
											if(defaultNav && defaultNav.children && defaultNav.children.length>0){
												let menus = defaultNav.children.filter(x=>x.type=='menu');
												if(menus && menus.length>0){
													this.$store.commit('setCurrentMenus',menus);
												}
											}
										}
										else{
											//直接获取module下的菜单
											let menuList = defaultModule.children.filter(x=>x.type=='menu');
											if(menuList && menuList.length>0){
												this.$store.commit('setCurrentMenus',menuList);
											}
										}
									}
								}
							}
                            this.$router.push({name:"Home"});
                        })
                    }else{
                    	this.reloadImgcode();
                    }
                });
            },
            reloadImgcode: function(){
                $("#img_verifycode").attr("src", "/htgl/imgCode/yzm?t=" + Math.random());
            },
			autoLogin:function(){
				    this.$http.post("/htgl/login",this.loginModel).then(res=>{
						this.$cookies.set("_xunw_admin_logined","1","0");
				    	// 将认证码存入SESSION
				        let data = res.data || {};
				        let user = { //用户
				            id:data.id,
				            js:data.js,
				            jsmc:data.jsmc,
				            yhm:data.yhm,
				            zsxm:data.zsxm,
				            jgId:data.jgId,
				        };
				        let privileges = data.qx || [];  //权限
				        this.$store.commit('setUser',user);
				        this.$store.commit('setPrivileges',privileges);
						//默认展示第一个模块的第一个导航的菜单
						if(privileges && privileges.length > 0){
							let modules = privileges.filter(x=>x.type=='module');
							if (modules && modules.length>0) {
								let defaultModule = modules[0];
								if (defaultModule && defaultModule.children && defaultModule.children.length>0){
									this.$store.commit('setActiveModule',defaultModule.code);
									let navs = defaultModule.children.filter(x=>x.type=='nav');
									if(navs && navs.length> 0){
										let defaultNav = navs[0];
										if(defaultNav && defaultNav.children && defaultNav.children.length>0){
											let menus = defaultNav.children.filter(x=>x.type=='menu');
											if(menus && menus.length>0){
												this.$store.commit('setCurrentMenus',menus);
											}
										}
									}
									else{
										//直接获取module下的菜单
										let menuList = defaultModule.children.filter(x=>x.type=='menu');
										if(menuList && menuList.length>0){
											this.$store.commit('setCurrentMenus',menuList);
										}
									}
								}
							}
						}
				        this.$router.push({name:"Home"});
				    });
			}
        }
    }
</script>
<style scoped>
   .form-bg {
		background: url(../../assets/login/login_bg_2020.png) no-repeat;
   }
   
   .form-horizontal {
   	background: #fff;
   	padding-bottom: 40px;
   	border-radius: 15px;
   	text-align: center;
   }
   
   .form-horizontal .heading {
   	display: block;
   	font-size: 25px;
   	font-weight: 700;
   	padding: 20px 0;
   	border-bottom: 1px solid #f0f0f0;
   	margin-bottom: 30px;
   }
   
   .form-horizontal .form-group {
   	padding: 0 40px;
   	margin: 0 0 25px 0;
   	position: relative;
   }
   
   .form-horizontal .form-control {
   	background: #f0f0f0;
   	border: none;
   	border-radius: 20px;
   	box-shadow: none;
   	padding: 0 20px 0 45px;
   	height: 40px;
   	transition: all 0.3s ease 0s;
   }
   
   .form-horizontal .form-control:focus {
   	background: #e0e0e0;
   	box-shadow: none;
   	outline: 0 none;
   }
   
   .form-horizontal .form-group i {
   	position: absolute;
   	top: 12px;
   	left: 60px;
   	font-size: 17px;
   	color: #c8c8c8;
   	transition: all 0.5s ease 0s;
   }
   
   .form-horizontal .form-control:focus+i {
   	color: #00b4ef;
   }
   
   .form-horizontal .fa-question-circle {
   	display: inline-block;
   	position: absolute;
   	top: 12px;
   	right: 60px;
   	font-size: 20px;
   	color: #808080;
   	transition: all 0.5s ease 0s;
   }
   
   .form-horizontal .fa-question-circle:hover {
   	color: #000;
   }
   
   .form-horizontal .main-checkbox {
   	float: left;
   	width: 20px;
   	height: 20px;
   	background: #11a3fc;
   	border-radius: 50%;
   	position: relative;
   	margin: 5px 0 0 5px;
   	border: 1px solid #11a3fc;
   }
   
   .form-horizontal .main-checkbox label {
   	width: 20px;
   	height: 20px;
   	position: absolute;
   	top: 0;
   	left: 0;
   	cursor: pointer;
   }
   
   .form-horizontal .main-checkbox label:after {
   	content: "";
   	width: 10px;
   	height: 5px;
   	position: absolute;
   	top: 5px;
   	left: 4px;
   	border: 3px solid #fff;
   	border-top: none;
   	border-right: none;
   	background: transparent;
   	opacity: 0;
   	-webkit-transform: rotate(-45deg);
   	transform: rotate(-45deg);
   }
   
   .form-horizontal .main-checkbox input[type=checkbox] {
   	visibility: hidden;
   }
   
   .form-horizontal .main-checkbox input[type=checkbox]:checked+label:after {
   	opacity: 1;
   }
   
   .form-horizontal .text {
   	float: left;
   	margin-left: 7px;
   	line-height: 20px;
   	padding-top: 5px;
   	text-transform: capitalize;
   }
   
   .form-horizontal .btn {
   	font-size: 14px;
   	color: #fff;
   	background: #00b4ef;
   	border-radius: 30px;
   	padding: 10px 85px;
   	border: none;
   	text-transform: capitalize;
   	transition: all 0.5s ease 0s;
   }
   
   @media only screen and (max-width: 479px) {
   	.form-horizontal .form-group {
   		padding: 0 25px;
   	}
   
   	.form-horizontal .form-group i {
   		left: 45px;
   	}
   
   	.form-horizontal .btn {
   		padding: 10px 20px;
   	}
   }
</style>